module.exports = __webpack_public_path__ + "img/ring_y_s_null_0@2x.9475e34f.png";